<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <software-update :version='storeState.data.deviceInfo.version'></software-update>
      </v-flex>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <factory-reset></factory-reset>
      </v-flex>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <trend-data-reset></trend-data-reset>
      </v-flex>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <reboot></reboot>
      </v-flex>
      <v-flex xs12 sm12 md12 class='pa-3'>
        <system-log></system-log>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import softwareUpdate from './BaseSoftwareUpdate.vue';
import factoryReset from './BaseFactoryReset.vue';
import trendDataReset from './BaseTrendDataReset.vue';
import reboot from './BaseReboot.vue';
import systemLog from './BaseSystemLog.vue';

export default {
  name: 'General',
  components: {
    softwareUpdate,
    factoryReset,
    trendDataReset,
    reboot,
    systemLog,
  },
  data() {
    return {
      storeState: this.$store.state,
    };
  },
};
</script>
